import styled from '@emotion/styled';
import { KpiState } from '../../helpers/kpi';
import { theme } from '../../theme';
import { COLOR as BADGE_COLOR } from '../badge/Badge';

export const badgeStateToColor = (state: KpiState) => {
  switch (state) {
    case 'success':
      return BADGE_COLOR.SUCCESS;
    case 'warning':
      return BADGE_COLOR.WARNING;
    case 'danger':
      return BADGE_COLOR.DANGER;
    case 'normal':
    default:
      return BADGE_COLOR.NEUTRAL;
  }
};

export const getScoreColor = (state: KpiState) => {
  switch (state) {
    case 'success':
      return theme.colors.emotionSuccess.default;
    case 'warning':
      return theme.colors.emotionWarning.default;
    case 'danger':
      return theme.colors.emotionDanger.default;
    case 'normal':
    default:
      return theme.colors.text.primary;
  }
};

/** Round icon button used for the "navigate to detail" action in the card header. */
export const KpiCardIconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  padding: 0;
  border-radius: 50%;
  border: 1px solid ${theme.colors.brand.primary};
  background-color: transparent;
  color: ${theme.colors.brand.primary};
  cursor: pointer;
  transition:
    background-color 0.15s ease-in-out,
    color 0.15s ease-in-out;

  svg {
    width: 16px;
    height: 16px;
  }

  svg path {
    fill: currentColor;
  }

  &:hover {
    background-color: ${theme.colors.brand.primary};
    color: ${theme.colors.textInverted.primary};
  }

  &:focus-visible {
    outline: 2px solid ${theme.colors.actionPrimary.focused};
    outline-offset: 2px;
  }
`;
